export const lookup: any = {
  rooms_overview_title: {
    EN: "Rooms overview",
    FR: "Aperçu des chambres",
    IT: "Panoramica delle camere",
  },
  no_rooms: {
    EN: "No rooms found",
    FR: "Aucune chambre trouvée",
    IT: "Nessuna stanza trovata",
  },
  no_rooms_subtext: {
    EN: "There are no rooms available within your property, create one!",
    FR: "Il n'y a pas de chambres disponibles dans votre propriété, créez-en une !",
    IT: "Non ci sono camere disponibili nella tua proprietà, creane una!",
  },
  no_requests: {
    EN: "No open actionable requests",
    FR: "Aucune demande d'action ouverte",
    IT: "Nessuna richiesta aperta azionabile",
  },
  no_requests_subtext: {
    EN: "There are no open requests to be actioned within the chosen time window!",
    FR: "Il n'y a pas de demandes ouvertes à traiter dans la fenêtre de temps choisie !",
    IT: "Non ci sono richieste aperte da eseguire nella finestra temporale scelta!",
  },
  actionable_request: {
    EN: "actionable request",
    FR: "demande d'action",
    IT: "richiesta azionabile",
  },
  actionable_requests: {
    EN: "actionable requests",
    FR: "demandes d'action",
    IT: "richieste azionabili",
  },
  created_at: {
    EN: "Created at",
    FR: "Créé à",
    IT: "Creato a",
  },
  name: {
    EN: "Name",
    FR: "Nom",
    IT: "Nome",
  },
  devices: {
    EN: "Devices",
    FR: "Appareils",
    IT: "Dispositivi",
  },
  tag: {
    EN: "Tags",
    FR: "Étiquettes",
    IT: "Tag",
  },
  tag_single: {
    EN: "Tag",
    FR: "Étiquette",
    IT: "Tag",
  },
  tag_placeholder: {
    EN: "Enter some tags",
    FR: "Entrez des étiquettes",
    IT: "Inserisci alcuni tag",
  },
  select_tags_for_rooms_announcement: {
    EN: "Select the tags to apply this announcement to",
    FR: "Sélectionnez les étiquettes à appliquer à cette annonce",
    IT: "Seleziona i tag da applicare a questo annuncio",
  },
  tag_small: {
    EN: "Write tags separated by a comma and press Enter",
    FR: "Écrivez des étiquettes séparées par une virgule et appuyez sur Entrée",
    IT: "Scrivi tag separati da una virgola e premi Invio",
  },
  request_options: {
    EN: "Request options",
    FR: "Options de demande",
    IT: "Opzioni di richiesta",
  },
  request_options_subtext: {
    EN: "Select the requests to enable for this room",
    FR: "Sélectionnez les demandes à activer pour cette pièce",
    IT: "Seleziona le richieste da abilitare per questa stanza",
  },
  select_all: {
    EN: "Select all",
    FR: "Tout sélectionner",
    IT: "Seleziona tutto",
  },
  unselect_all: {
    EN: "Unselect all",
    FR: "Tout désélectionner",
    IT: "Deseleziona tutto",
  },
  allow_announcements: {
    EN: "Allow announcements",
    FR: "Autoriser les annonces",
    IT: "Consenti annunci",
  },
  allow_announcements_description: {
    EN: "Enable this toggle to allow this room to receive announcements",
    FR: "Activez ce commutateur pour permettre à cette pièce de recevoir des annonces",
    IT: "Abilita questa levetta per consentire a questa stanza di ricevere annunci",
  },
  rooms_templates_title: {
    EN: "Room templates",
    FR: "Modèles de pièces",
    IT: "Modelli di stanze",
  },
  create_template: {
    EN: "Create template",
    FR: "Créer un modèle",
    IT: "Crea un modello",
  },
  requests: {
    EN: "requests",
    FR: "demandes",
    IT: "richieste",
  },
  no_request_templates: {
    EN: "No request templates found",
    FR: "Aucun modèle de demande trouvé",
    IT: "Nessun modello di richiesta trovato",
  },
  no_request_templates_subtext: {
    EN: "There are no request templates available within your property, create one!",
    FR: "Il n'y a pas de modèles de demande disponibles dans votre propriété, créez-en un !",
    IT: "Non ci sono modelli di richiesta disponibili nella tua proprietà, creane uno!",
  },
  edit_template: {
    EN: "Edit template",
    FR: "Modifier le modèle",
    IT: "Modifica modello",
  },
  cancel: {
    EN: "Cancel",
    FR: "Annuler",
    IT: "Annulla",
  },
  template_options_subtext: {
    EN: "Select the requests to enable for this template",
    FR: "Sélectionnez les demandes à activer pour ce modèle",
    IT: "Seleziona le richieste da abilitare per questo modello",
  },
  missing_name: {
    EN: "Missing name",
    FR: "Nom manquant",
    IT: "Nome mancante",
  },
  missing_request_options: {
    EN: "Missing request options",
    FR: "Options de demande manquantes",
    IT: "Opzioni di richiesta mancanti",
  },
  created_by: {
    EN: "Created by",
    FR: "Créé par",
    IT: "Creato da",
  },
  updated_by: {
    EN: "Updated by",
    FR: "Mis à jour par",
    IT: "Aggiornato da",
  },
  rooms: {
    EN: "Rooms",
    FR: "Chambres",
    IT: "Stanze",
  },
  rooms_template_subtext: {
    EN: "Select the rooms to apply this template to",
    FR: "Sélectionnez les pièces auxquelles appliquer ce modèle",
    IT: "Seleziona le stanze a cui applicare questo modello",
  },
  danger_zone: {
    EN: "Danger zone",
    FR: "Zone de danger",
    IT: "Zona pericolosa",
  },
  danger_zone_subtext: {
    EN: "Be careful, clicking the button below will delete this object",
    FR: "Attention, cliquer sur le bouton ci-dessous supprimera cet objet",
    IT: "Attenzione, cliccando sul pulsante sottostante verrà eliminato questo oggetto",
  },
  danger_zone_confirmation: {
    EN: "Are you sure you want to delete this object? This action cannot be undone.",
    FR: "Êtes-vous sûr de vouloir supprimer cet objet ? Cette action ne peut pas être annulée.",
    IT: "Sei sicuro di voler eliminare questo oggetto? Questa azione non può essere annullata.",
  },
  delete_yes: {
    EN: "Yes, delete",
    FR: "Oui, supprimer",
    IT: "Sì, elimina",
  },
  delete_no: {
    EN: "No, cancel",
    FR: "Non, annuler",
    IT: "No, annulla",
  },
  edit_device: {
    EN: "Edit device",
    FR: "Modifier l'appareil",
    IT: "Modifica dispositivo",
  },
  no_devices: {
    EN: "No devices found",
    FR: "Aucun appareil trouvé",
    IT: "Nessun dispositivo trovato",
  },
  no_devices_subtext: {
    EN: "There are no devices available within your property!",
    FR: "Il n'y a pas d'appareils disponibles dans votre propriété !",
    IT: "Non ci sono dispositivi disponibili nella tua proprietà!",
  },
  devices_title: {
    EN: "Devices",
    FR: "Appareils",
    IT: "Dispositivi",
  },
  unknown: {
    EN: "Unknown",
    FR: "Inconnu",
    IT: "Sconosciuto",
  },
  offline: {
    EN: "Offline",
    FR: "Hors ligne",
    IT: "Disconnesso",
  },
  online: {
    EN: "Online",
    FR: "En ligne",
    IT: "In linea",
  },
  model: {
    EN: "Model",
    FR: "Modèle",
    IT: "Modello",
  },
  serial_number: {
    EN: "Serial number",
    FR: "Numéro de série",
    IT: "Numero di serie",
  },
  associated_room: {
    EN: "Associated room",
    FR: "Pièce associée",
    IT: "Stanza associata",
  },
  choose_associated_room: {
    EN: "Choose a room to associate the device with",
    FR: "Choisissez une pièce pour associer l'appareil",
    IT: "Scegli una stanza da associare al dispositivo",
  },
  analytics_title: {
    EN: "Analytics",
    FR: "Analytique",
    IT: "Analisi",
  },
  not_enough_data: {
    EN: "Not enough data!",
    FR: "Pas assez de données !",
    IT: "Non abbastanza dati !",
  },
  not_enough_data_analytics_subtext: {
    EN: "There is not enough data to display analytics, check back later!",
    FR: "Il n'y a pas assez de données pour afficher l'analyse, revenez plus tard !",
    IT: "Non ci sono dati sufficienti per visualizzare le analisi, riprova più tardi!",
  },
  analytics_request_time_series: {
    EN: "Request time series",
    FR: "Série temporelle de demande",
    IT: "Serie temporale della richiesta",
  },
  analytics_request_time_series_subtext: {
    EN: "How many requests have been made over time?",
    FR: "Combien de demandes ont été faites au fil du temps ?",
    IT: "Quante richieste sono state fatte nel tempo?",
  },
  analytics_category_frequency: {
    EN: "Category frequency",
    FR: "Fréquence de la catégorie",
    IT: "Frequenza della categoria",
  },
  analytics_category_frequency_subtext: {
    EN: "See the number of requests made per category",
    FR: "Voir le nombre de demandes effectuées par catégorie",
    IT: "Vedi il numero di richieste effettuate per categoria",
  },
  analytics_room_frequency: {
    EN: "Room frequency",
    FR: "Fréquence de la pièce",
    IT: "Frequenza della stanza",
  },
  analytics_room_frequency_subtext: {
    EN: "See the number of requests made per room",
    FR: "Voir le nombre de demandes effectuées par pièce",
    IT: "Vedi il numero di richieste effettuate per stanza",
  },
  orange_limit: {
    EN: "Orange limit",
    FR: "Limite orange",
    IT: "Limite arancione",
  },
  red_limit: {
    EN: "Red limit",
    FR: "Limite rouge",
    IT: "Limite rossa",
  },
  average_response_time: {
    EN: "Average response time",
    FR: "Temps de réponse moyen",
    IT: "Tempo medio di risposta",
  },
  lower_limit: {
    EN: "Lower limit",
    FR: "Limite inférieure",
    IT: "Limite inferiore",
  },
  upper_limit: {
    EN: "Upper limit",
    FR: "Limite supérieure",
    IT: "Limite superiore",
  },
  average: {
    EN: "Average",
    FR: "Moyenne",
    IT: "Media",
  },
  analytics_average_response_time_subtext: {
    EN: "See the average response time in minutes for requests",
    FR: "Voir le temps de réponse moyen en minutes pour les demandes",
    IT: "Vedi il tempo di risposta medio in minuti per le richieste",
  },
  download_data: {
    EN: "Download data as:",
    FR: "Télécharger les données sous forme de:",
    IT: "Scarica i dati come:",
  },
  log_title: {
    EN: "Log",
    FR: "Journal",
    IT: "Registro",
  },
  not_enough_data_log_subtext: {
    EN: "There is not enough data to display the log, check back later!",
    FR: "Il n'y a pas assez de données pour afficher le journal, revenez plus tard !",
    IT: "Non ci sono dati sufficienti per visualizzare il registro, riprova più tardi!",
  },
  non_actionable_requests: {
    EN: "Non-actionable requests",
    FR: "Demandes non-actionnables",
    IT: "Richieste non azionabili",
  },
  content: {
    EN: "Content",
    FR: "Contenu",
    IT: "Contenuto",
  },
  undo: {
    EN: "Undo",
    FR: "Annuler",
    IT: "Annulla",
  },
  not_enough_data_log_content_subtext: {
    EN: "There is not enough data to display the content log, check back later!",
    FR: "Il n'y a pas assez de données pour afficher le journal du contenu, revenez plus tard !",
    IT: "Non ci sono dati sufficienti per visualizzare il registro dei contenuti, riprova più tardi!",
  },
  not_enough_data_log_non_actionable_subtext: {
    EN: "There is not enough data to display the non-actionable log, check back later!",
    FR: "Il n'y a pas assez de données pour afficher le journal des non-actionnables, revenez plus tard !",
    IT: "Non ci sono dati sufficienti per visualizzare il registro dei non azionabili, riprova più tardi!",
  },
  announcements_title: {
    EN: "Announcements",
    FR: "Annonces",
    IT: "Annunci",
  },
  create_announcement: {
    EN: "Create announcement",
    FR: "Créer une annonce",
    IT: "Crea un annuncio",
  },
  text: {
    EN: "Text",
    FR: "Texte",
    IT: "Testo",
  },
  no_announcements: {
    EN: "No announcements found",
    FR: "Aucune annonce trouvée",
    IT: "Nessun annuncio trovato",
  },
  no_announcements_subtext: {
    EN: "There are no announcements available within your property, create one!",
    FR: "Il n'y a pas d'annonces disponibles dans votre propriété, créez-en une !",
    IT: "Non ci sono annunci disponibili nella tua proprietà, creane uno!",
  },
  type: {
    EN: "Type",
    FR: "Type",
    IT: "Tipo",
  },
  choose_rooms_by: {
    EN: "Choose rooms by",
    FR: "Choisissez les pièces par",
    IT: "Scegli le stanze per",
  },
  choose_rooms_by_subtext: {
    EN: "You can send announcements by selecting each room by name, or to all rooms that match a chosen tag",
    FR: "Vous pouvez envoyer des annonces en sélectionnant chaque pièce par nom, ou à toutes les pièces qui correspondent à une étiquette choisie",
    IT: "Puoi inviare annunci selezionando ogni stanza per nome o a tutte le stanze che corrispondono a un tag scelto",
  },
  one_off: {
    EN: "One off",
    FR: "Unique",
    IT: "Una tantum",
  },
  recurring: {
    EN: "Recurring",
    FR: "Récurrent",
    IT: "Ricorrente",
  },
  recurrence: {
    EN: "Recurrence",
    FR: "Récurrence",
    IT: "Ricorrenza",
  },
  recurrence_announcement_subtext: {
    EN: "Do you want to send a one off announcement or schedule it to repeat on a recurring basis?",
    FR: "Voulez-vous envoyer une annonce unique ou la planifier pour qu'elle se répète de manière récurrente ?",
    IT: "Vuoi inviare un annuncio una tantum o pianificarlo per ripetersi periodicamente?",
  },
  schedule: {
    EN: "Schedule",
    FR: "Calendrier",
    IT: "Programma",
  },
  schedule_announcement_subtext: {
    EN: "Do you want to send the announcement now or for a time in the future?",
    FR: "Voulez-vous envoyer l'annonce maintenant ou pour un moment dans le futur ?",
    IT: "Vuoi inviare l'annuncio ora o per un momento in futuro?",
  },
  now: {
    EN: "Now",
    FR: "Maintenant",
    IT: "Ora",
  },
  future: {
    EN: "Future",
    FR: "Futur",
    IT: "Futuro",
  },
  hour: {
    EN: "Hour",
    FR: "Heure",
    IT: "Ora",
  },
  minute: {
    EN: "Minute",
    FR: "Minute",
    IT: "Minuto",
  },
  recurring_schedule: {
    EN: "Recurring schedule",
    FR: "Calendrier récurrent",
    IT: "Calendario ricorrente",
  },
  recurring_schedule_announcement_subtext: {
    EN: "Do you want the announcement to be sent at regular intervals or specific repeated times?",
    FR: "Voulez-vous que l'annonce soit envoyée à intervalles réguliers ou à des moments répétés spécifiques ?",
    IT: "Vuoi che l'annuncio venga inviato a intervalli regolari o a orari specifici ripetuti?",
  },
  every: {
    EN: "Every",
    FR: "Chaque",
    IT: "Ogni",
  },
  start_from: {
    EN: "Starting from",
    FR: "À partir de",
    IT: "A partire da",
  },
  period: {
    EN: "Period",
    FR: "Période",
    IT: "Periodo",
  },
  at_time: {
    EN: "At time",
    FR: "À l'heure",
    IT: "All'ora",
  },
  scheduled_for: {
    EN: "Scheduled for",
    FR: "Prévu pour",
    IT: "Programmato per",
  },
  last_updated: {
    EN: "Last updated",
    FR: "Dernière mise à jour",
    IT: "Ultimo aggiornamento",
  },
  schedule_type: {
    EN: "Schedule type",
    FR: "Type de calendrier",
    IT: "Tipo di programma",
  },
  destination: {
    EN: "Destination",
    FR: "Destination",
    IT: "Destinazione",
  },
  status: {
    EN: "Status",
    FR: "Statut",
    IT: "Stato",
  },
  run_count: {
    EN: "Run count",
    FR: "Nombre d'exécutions",
    IT: "Conteggio di esecuzione",
  },
  contact_books_title: {
    EN: "Contact books",
    FR: "Carnets d'adresses",
    IT: "Rubriche",
  },
  no_contact_books: {
    EN: "No contact books found",
    FR: "Aucun carnet d'adresses trouvé",
    IT: "Nessun rubrica trovata",
  },
  no_contact_books_subtext: {
    EN: "There are no contact books available within your property, create one!",
    FR: "Il n'y a pas de carnets d'adresses disponibles dans votre propriété, créez-en un !",
    IT: "Non ci sono rubriche disponibili nella tua proprietà, creane una!",
  },
  create_contact_book: {
    EN: "Create contact book",
    FR: "Créer un carnet d'adresses",
    IT: "Crea una rubrica",
  },
  contact: {
    EN: "Contact",
    FR: "Contact",
    IT: "Contatto",
  },
  enter_contact_name: {
    EN: "Enter name for contact",
    FR: "Entrez le nom du contact",
    IT: "Inserisci il nome del contatto",
  },
  alexa: {
    EN: "Alexa",
    FR: "Alexa",
    IT: "Alexa",
  },
  phone_number: {
    EN: "Phone number",
    FR: "Numéro de téléphone",
    IT: "Numero di telefono",
  },
  enter_phone_numbers: {
    EN: "Enter phone numbers",
    FR: "Entrez les numéros de téléphone",
    IT: "Inserisci i numeri di telefono",
  },
  choose_room: {
    EN: "Choose a room",
    FR: "Choisissez une pièce",
    IT: "Scegli una stanza",
  },
  room: {
    EN: "Room",
    FR: "Pièce",
    IT: "Stanza",
  },
  phone_numbers_limit: {
    EN: "You can enter up to 3 phone numbers by separating them with a comma",
    FR: "Vous pouvez entrer jusqu'à 3 numéros de téléphone en les séparant par une virgule",
    IT: "Puoi inserire fino a 3 numeri di telefono separandoli con una virgola",
  },
  contact_room_type: {
    EN: "Is this contact a room within the property or a phone number?",
    FR: "Ce contact est-il une pièce de la propriété ou un numéro de téléphone ?",
    IT: "Questo contatto è una stanza all'interno della proprietà o un numero di telefono?",
  },
  add_another_contact: {
    EN: "Add another contact",
    FR: "Ajouter un autre contact",
    IT: "Aggiungi un altro contatto",
  },
  contact_lower: {
    EN: "contact",
    FR: "carnet d'adresses",
    IT: "contatto",
  },
  contacts_lower: {
    EN: "contacts",
    FR: "carnets d'adresses",
    IT: "contatti",
  },
  edit_contact_book: {
    EN: "Edit contact book",
    FR: "Modifier le carnet d'adresses",
    IT: "Modifica rubrica",
  },
  calling_title: {
    EN: "Calling",
    FR: "Appel",
    IT: "Chiamata",
  },
  choose_rooms_by_contact_subtext: {
    EN: "You can apply contact books to room by name, or to all rooms that match a chosen contact",
    FR: "Vous pouvez appliquer des carnets d'adresses à une pièce par nom, ou à toutes les pièces qui correspondent à un contact choisi",
    IT: "Puoi applicare rubriche alle stanze per nome o a tutte le stanze che corrispondono a un contatto scelto",
  },
  reciprocate_title: {
    EN: "Reciprocate phone numbers",
    FR: "Réciprocité des numéros de téléphone",
    IT: "Ricambiare i numeri di telefono",
  },
  no_valid_rooms: {
    EN: "No valid rooms found",
    FR: "Aucune pièce valide trouvée",
    IT: "Nessuna stanza valida trovata",
  },
  invalid_reciprocation_subtext: {
    EN: "There are no rooms with external contacts available to reciprocate!",
    FR: "Il n'y a pas de pièces avec des contacts externes disponibles pour la réciprocité !",
    IT: "Non ci sono stanze con contatti esterni disponibili per la reciprocità!",
  },
  reciprocate_external_contacts: {
    EN: "Reciprocate external contacts",
    FR: "Réciprocité des contacts externes",
    IT: "Ricambiare i contatti esterni",
  },
  campaigns_title: {
    EN: "Campaigns",
    FR: "Campagnes",
    IT: "Campagne",
  },
  create_campaign: {
    EN: "Create campaign",
    FR: "Créer une campagne",
    IT: "Crea una campagna",
  },
  no_campaigns: {
    EN: "No campaigns found",
    FR: "Aucune campagne trouvée",
    IT: "Nessuna campagna trovata",
  },
  no_campaigns_subtext: {
    EN: "There are no campaigns available within your property, create one!",
    FR: "Il n'y a pas de campagnes disponibles dans votre propriété, créez-en une !",
    IT: "Non ci sono campagne disponibili nella tua proprietà, creane una!",
  },
  content_campaign_type: {
    EN: "Content type",
    FR: "Type de contenu",
    IT: "Tipo di contenuto",
  },
  content_campaign_type_subtext: {
    EN: "Do you want the content in this campaign to be static or do you want it to use the latest data from your property when it runs?",
    FR: "Voulez-vous que le contenu de cette campagne soit statique ou voulez-vous qu'il utilise les dernières données de votre propriété lorsqu'il s'exécute ?",
    IT: "Vuoi che il contenuto di questa campagna sia statico o vuoi che utilizzi gli ultimi dati della tua proprietà quando viene eseguito?",
  },
  static: {
    EN: "Static",
    FR: "Statique",
    IT: "Statico",
  },
  dynamic: {
    EN: "Dynamic",
    FR: "Dynamique",
    IT: "Dinamico",
  },
  template: {
    EN: "Using a template",
    FR: "En utilisant un modèle",
    IT: "Utilizzando un modello",
  },
  custom: {
    EN: "Build something custom",
    FR: "Construire quelque chose de personnalisé",
    IT: "Costruisci qualcosa di personalizzato",
  },
  build_type: {
    EN: "Build type",
    FR: "Type de construction",
    IT: "Tipo di costruzione",
  },
  build_type_subtext: {
    EN: "Do you want to use a template or build something custom?",
    FR: "Voulez-vous utiliser un modèle ou construire quelque chose de personnalisé ?",
    IT: "Vuoi utilizzare un modello o costruire qualcosa di personalizzato?",
  },
  description: {
    EN: "Description",
    FR: "Description",
    IT: "Descrizione",
  },
  content_campaign_display_type: {
    EN: "Display type",
    FR: "Type d'affichage",
    IT: "Tipo di visualizzazione",
  },
  content_campaign_display_type_subtext: {
    EN: "Do you want this content to be added to the rotating carousel of content or do you want to pin it to the display?",
    FR: "Voulez-vous que ce contenu soit ajouté au carrousel de contenu rotatif ou voulez-vous l'épingler à l'écran ?",
    IT: "Vuoi che questo contenuto venga aggiunto al carosello di contenuti rotanti o vuoi fissarlo al display?",
  },
  rotating: {
    EN: "Rotating",
    FR: "Rotation",
    IT: "Rotazione",
  },
  pinned: {
    EN: "Pinned",
    FR: "Épinglé",
    IT: "Pinned",
  },
  choose_from_catalog: {
    EN: "Choose from catalog",
    FR: "Choisir dans le catalogue",
    IT: "Scegli dal catalogo",
  },
  upload: {
    EN: "Upload",
    FR: "Télécharger",
    IT: "Caricare",
  },
  background_image: {
    EN: "Background image",
    FR: "Image d'arrière-plan",
    IT: "Immagine di sfondo",
  },
  background_image_campaign_subtext: {
    EN: "Would you like to choose an image from our catalog or upload one of your own?",
    FR: "Voulez-vous choisir une image dans notre catalogue ou en télécharger une de votre choix ?",
    IT: "Vuoi scegliere un'immagine dal nostro catalogo o caricarne una tua?",
  },
  upload_photo: {
    EN: "Click to select images or drag and drop here!",
    FR: "Cliquez pour sélectionner des images ou faites-les glisser et déposez-les ici !",
    IT: "Fai clic per selezionare le immagini o trascinale qui!",
  },
  header: {
    EN: "Header",
    FR: "En-tête",
    IT: "Intestazione",
  },
  header_placeholder: {
    EN: "Enter a header",
    FR: "Entrez un en-tête",
    IT: "Inserisci un'intestazione",
  },
  primary_text: {
    EN: "Primary text",
    FR: "Texte principal",
    IT: "Testo principale",
  },
  primary_text_placeholder: {
    EN: "Enter primary text",
    FR: "Entrez le texte principal",
    IT: "Inserisci il testo principale",
  },
  secondary_text: {
    EN: "Secondary text",
    FR: "Texte secondaire",
    IT: "Testo secondario",
  },
  secondary_text_placeholder: {
    EN: "Enter secondary text",
    FR: "Entrez le texte secondaire",
    IT: "Inserisci il testo secondario",
  },
  name_campaign_placeholder: {
    EN: "Enter a name for this campaign",
    FR: "Entrez un nom pour la campagne",
    IT: "Inserisci un nome per questa campagna",
  },
  description_campaign_placeholder: {
    EN: "Enter a description for this campaign",
    FR: "Entrez une description pour cette campagne",
    IT: "Inserisci una descrizione per questa campagna",
  },
  select_tags_for_rooms_campaign: {
    EN: "Select the tags to apply this campaign to",
    FR: "Sélectionnez les étiquettes à appliquer à cette campagne",
    IT: "Seleziona i tag da applicare a questa campagna",
  },
  start_datetime: {
    EN: "Start date and time",
    FR: "Date et heure de début",
    IT: "Data e ora di inizio",
  },
  end_datetime: {
    EN: "End date and time",
    FR: "Date et heure de fin",
    IT: "Data e ora di fine",
  },
  title: {
    EN: "Title",
    FR: "Titre",
    IT: "Titolo",
  },
  title_placeholder: {
    EN: "Enter a title",
    FR: "Entrez un titre",
    IT: "Inserisci un titolo",
  },
  body: {
    EN: "Body",
    FR: "Corps",
    IT: "Corpo",
  },
  body_placeholder: {
    EN: "Enter a body",
    FR: "Entrez un corps",
    IT: "Inserisci un corpo",
  },
  template_type: {
    EN: "Choose a template",
    FR: "Choisissez un modèle",
    IT: "Scegli un modello",
  },
  template_type_subtext: {
    EN: "Choose a template to use for this campaign",
    FR: "Choisissez un modèle à utiliser pour cette campagne",
    IT: "Scegli un modello da utilizzare per questa campagna",
  },
  select_template_type: {
    EN: "Select a template",
    FR: "Sélectionnez un modèle",
    IT: "Seleziona un modello",
  },
  schedule_dynamic_campaign_subtext: {
    EN: "How often do you want this campaign to run?",
    FR: "À quelle fréquence voulez-vous que cette campagne s'exécute ?",
    IT: "Con quale frequenza vuoi che questa campagna venga eseguita?",
  },
  from: {
    EN: "From",
    FR: "De",
    IT: "Da",
  },
  until: {
    EN: "Until",
    FR: "Jusqu'à",
    IT: "Fino a",
  },
  days_of_week: {
    EN: "Days of the week",
    FR: "Jours de la semaine",
    IT: "Giorni della settimana",
  },
  days_of_week_campaign_subtext: {
    EN: "Select the days of the week to run this campaign on",
    FR: "Sélectionnez les jours de la semaine pour exécuter cette campagne",
    IT: "Seleziona i giorni della settimana in cui eseguire questa campagna",
  },
  days_of_month: {
    EN: "Days of the month",
    FR: "Jours du mois",
    IT: "Giorni del mese",
  },
  days_of_month_campaign_subtext: {
    EN: "Select the days of the month to run this campaign on",
    FR: "Sélectionnez les jours du mois pour exécuter cette campagne",
    IT: "Seleziona i giorni del mese in cui eseguire questa campagna",
  },
  edit_campaign: {
    EN: "Edit campaign",
    FR: "Modifier la campagne",
    IT: "Modifica campagna",
  },
  all: {
    EN: "All",
    FR: "Tous",
    IT: "Tutti",
  },
  template_single: {
    EN: "Template",
    FR: "Modèle",
    IT: "Modello",
  },
  photo_albums_title: {
    EN: "Photo albums",
    FR: "Albums photo",
    IT: "Album fotografici",
  },
  create_photo_album: {
    EN: "Create photo album",
    FR: "Créer un album photo",
    IT: "Crea un album fotografico",
  },
  edit_photo_album: {
    EN: "Edit photo album",
    FR: "Modifier l'album photo",
    IT: "Modifica album fotografico",
  },
  no_photo_albums: {
    EN: "No photo albums found",
    FR: "Aucun album photo trouvé",
    IT: "Nessun album fotografico trovato",
  },
  no_photo_albums_subtext: {
    EN: "There are no photo albums available within your property, create one!",
    FR: "Il n'y a pas d'albums photo disponibles dans votre propriété, créez-en un !",
    IT: "Non ci sono album fotografici disponibili nella tua proprietà, creane uno!",
  },
  images: {
    EN: "Images",
    FR: "Images",
    IT: "Immagini",
  },
  photos: {
    EN: "Photos",
    FR: "Photos",
    IT: "Foto",
  },
  photo: {
    EN: "Photo",
    FR: "Photo",
    IT: "Foto",
  },
  events_title: {
    EN: "Events",
    FR: "Événements",
    IT: "Eventi",
  },
  create_event: {
    EN: "Create event",
    FR: "Créer un événement",
    IT: "Crea un evento",
  },
  no_events: {
    EN: "No events found",
    FR: "Aucun événement trouvé",
    IT: "Nessun evento trovato",
  },
  no_events_subtext: {
    EN: "There are no events available within your property, create one!",
    FR: "Il n'y a pas d'événements disponibles dans votre propriété, créez-en un !",
    IT: "Non ci sono eventi disponibili nella tua proprietà, creane uno!",
  },
  event_schedule_subtext: {
    EN: "Is this a one-off event or does it repeat on a recurring basis?",
    FR: "S'agit-il d'un événement unique ou se répète-t-il de manière récurrente ?",
    IT: "Si tratta di un evento unico o si ripete periodicamente?",
  },
  target_rooms: {
    EN: "Target rooms",
    FR: "Pièces cibles",
    IT: "Stanze di destinazione",
  },
  target_rooms_subtext: {
    EN: "Do you want this event to apply to all rooms or a specific selection?",
    FR: "Voulez-vous que cet événement s'applique à toutes les pièces ou à une sélection spécifique ?",
    IT: "Vuoi che questo evento si applichi a tutte le stanze o a una selezione specifica?",
  },
  target_rooms_task_subtext: {
    EN: "Do you want this task to apply to all rooms or a specific selection?",
    FR: "Voulez-vous que cette tâche s'applique à toutes les pièces ou à une sélection spécifique ?",
    IT: "Vuoi che questo compito si applichi a tutte le stanze o a una selezione specifica?",
  },
  specific: {
    EN: "Specific",
    FR: "Spécifique",
    IT: "Specifico",
  },
  recurring_schedule_type: {
    EN: "Recurring period",
    FR: "Période récurrente",
    IT: "Periodo ricorrente",
  },
  recurring_schedule_type_event_subtext: {
    EN: "Choose a recurring period that this event will repeat on",
    FR: "Choisissez une période récurrente sur laquelle cet événement se répétera",
    IT: "Scegli un periodo ricorrente in cui si ripeterà questo evento",
  },
  start_time: {
    EN: "Start time",
    FR: "Heure de début",
    IT: "Ora di inizio",
  },
  end_time: {
    EN: "End time",
    FR: "Heure de fin",
    IT: "Ora di fine",
  },
  add_another_time: {
    EN: "Add another time",
    FR: "Ajouter une autre heure",
    IT: "Aggiungi un'altra ora",
  },
  select_dates: {
    EN: "Select dates",
    FR: "Sélectionnez des dates",
    IT: "Seleziona date",
  },
  edit_event: {
    EN: "Edit event",
    FR: "Modifier l'événement",
    IT: "Modifica evento",
  },
  status_event_subtext: {
    EN: 'Switch this toggle on to enable this event as "active"',
    FR: 'Activez ce commutateur pour activer cet événement en tant que "actif"',
    IT: 'Attiva questo interruttore per abilitare questo evento come "attivo"',
  },
  status_album_subtext: {
    EN: 'Switch this toggle on to enable this photo album as "active"',
    FR: 'Activez ce commutateur pour activer cet album photo en tant que "actif"',
    IT: 'Attiva questo interruttore per abilitare questo album fotografico come "attivo"',
  },
  services_title: {
    EN: "Services",
    FR: "Services",
    IT: "Servizi",
  },
  create_service: {
    EN: "Create service",
    FR: "Créer un service",
    IT: "Crea un servizio",
  },
  directions: {
    EN: "Directions",
    FR: "Indications",
    IT: "Indicazioni",
  },
  availability: {
    EN: "Availability",
    FR: "Disponibilité",
    IT: "Disponibilità",
  },
  edit_service: {
    EN: "Edit service",
    FR: "Modifier le service",
    IT: "Modifica servizio",
  },
  status_service_subtext: {
    EN: 'Switch this toggle on to enable this service as "active"',
    FR: 'Activez ce commutateur pour activer ce service en tant que "actif"',
    IT: 'Attiva questo interruttore per abilitare questo servizio come "attivo"',
  },
  status_task_subtext: {
    EN: 'Switch this toggle on to enable this task as "active"',
    FR: 'Activez ce commutateur pour activer cette tâche en tant que "actif"',
    IT: 'Attiva questo interruttore per abilitare questo compito come "attivo"',
  },
  no_services_subtext: {
    EN: "There are no services available within your property, create one!",
    FR: "Il n'y a pas de services disponibles dans votre propriété, créez-en un !",
    IT: "Non ci sono servizi disponibili nella tua proprietà, creane uno!",
  },
  no_services: {
    EN: "No services found",
    FR: "Aucun service trouvé",
    IT: "Nessun servizio trovato",
  },
  category: {
    EN: "Category",
    FR: "Catégorie",
    IT: "Categoria",
  },
  always_open: {
    EN: "Always open",
    FR: "Toujours ouvert",
    IT: "Sempre aperto",
  },
  menus_title: {
    EN: "Menus",
    FR: "Menus",
    IT: "Menu",
  },
  create_menu: {
    EN: "Create menu",
    FR: "Créer un menu",
    IT: "Crea un menu",
  },
  meal_time: {
    EN: "Meal time",
    FR: "Heure du repas",
    IT: "Orario dei pasti",
  },
  items: {
    EN: "Items",
    FR: "Articles",
    IT: "Articoli",
  },
  start_date: {
    EN: "Start date",
    FR: "Date de début",
    IT: "Data d'inizio",
  },
  end_date: {
    EN: "End date",
    FR: "Date de fin",
    IT: "Data di fine",
  },
  recurring_schedule_choices: {
    EN: "Recurring schedule choices",
    FR: "Choix de l'horaire récurrent",
    IT: "Scelte di programmazione ricorrente",
  },
  add_another_day: {
    EN: "Add another day",
    FR: "Ajouter un autre jour",
    IT: "Aggiungi un altro giorno",
  },
  edit_menu: {
    EN: "Edit menu",
    FR: "Modifier le menu",
    IT: "Modifica menu",
  },
  status_menu_subtext: {
    EN: 'Switch this toggle on to enable this menu as "active"',
    FR: 'Activez ce commutateur pour activer ce menu en tant que "actif"',
    IT: 'Attiva questo interruttore per abilitare questo menu come "attivo"',
  },
  no_menus_subtext: {
    EN: "There are no menus available within your property, create one!",
    FR: "Il n'y a pas de menus disponibles dans votre propriété, créez-en un !",
    IT: "Non ci sono menu disponibili nella tua proprietà, creane uno!",
  },
  no_menus: {
    EN: "No menus found",
    FR: "Aucun menu trouvé",
    IT: "Nessun menu trovato",
  },
  newsletters_title: {
    EN: "Newsletters",
    FR: "Lettres d'information",
    IT: "Newsletter",
  },
  create_newsletter: {
    EN: "Create newsletter",
    FR: "Créer une newsletter",
    IT: "Crea una newsletter",
  },
  edit_newsletter: {
    EN: "Edit newsletter",
    FR: "Modifier la newsletter",
    IT: "Modifica newsletter",
  },
  no_newsletters_subtext: {
    EN: "There are no newsletters available within your property, create one!",
    FR: "Il n'y a pas de newsletters disponibles dans votre propriété, créez-en une !",
    IT: "Non ci sono newsletter disponibili nella tua proprietà, creane una!",
  },
  no_newsletters: {
    EN: "No newsletters found",
    FR: "Aucune newsletter trouvée",
    IT: "Nessuna newsletter trovata",
  },
  add_another_section: {
    EN: "Add another section",
    FR: "Ajouter une autre section",
    IT: "Aggiungi un'altra sezione",
  },
  section: {
    EN: "Section",
    FR: "Section",
    IT: "Sezione",
  },
  sections: {
    EN: "Sections",
    FR: "Sections",
    IT: "Sezioni",
  },
  add_header_for: {
    EN: "Add a header for",
    FR: "Ajouter un en-tête pour",
    IT: "Aggiungi un'intestazione per",
  },
  add_body_for: {
    EN: "Add a body for",
    FR: "Ajouter un corps pour",
    IT: "Aggiungi un corpo per",
  },
  build_type_newsletter_subtext: {
    EN: "Do you want create a newsletter from scratch or upload a CSV?",
    FR: "Voulez-vous créer une newsletter à partir de zéro ou télécharger un CSV ?",
    IT: "Vuoi creare una newsletter da zero o caricare un CSV?",
  },
  custom_newsletter: {
    EN: "From scratch",
    FR: "À partir de zéro",
    IT: "Da zero",
  },
  spreadsheet: {
    EN: "Spreadsheet",
    FR: "Feuille de calcul",
    IT: "Foglio di calcolo",
  },
  pdf: {
    EN: "PDF",
    FR: "PDF",
    IT: "PDF",
  },
  download_template: {
    EN: "Download template",
    FR: "Télécharger le modèle",
    IT: "Scarica il modello",
  },
  upload_file: {
    EN: "Drag and drop file here or click to browse",
    FR: "Faites glisser et déposez le fichier ici ou cliquez pour parcourir",
    IT: "Trascina e rilascia il file qui o fai clic per sfogliare",
  },
  activate_imported_data: {
    EN: "Activate imported data",
    FR: "Activer les données importées",
    IT: "Attiva i dati importati",
  },
  csv: {
    EN: "CSV",
    FR: "CSV",
    IT: "CSV",
  },
  status_newsletter_subtext: {
    EN: 'Switch this toggle on to enable this newsletter as "active"',
    FR: 'Activez ce commutateur pour activer cette newsletter en tant que "active"',
    IT: 'Attiva questo interruttore per abilitare questa newsletter come "attiva"',
  },
  weblinks_title: {
    EN: "Weblinks",
    FR: "Liens Web",
    IT: "Collegamenti web",
  },
  create_weblink: {
    EN: "Create weblink",
    FR: "Créer un lien web",
    IT: "Crea un collegamento web",
  },
  edit_weblink: {
    EN: "Update weblink",
    FR: "Mettre à jour le lien web",
    IT: "Aggiorna collegamento web",
  },
  no_weblinks_subtext: {
    EN: "There are no weblinks available within your property, create one!",
    FR: "Il n'y a pas de liens web disponibles dans votre propriété, créez-en un !",
    IT: "Non ci sono collegamenti web disponibili nella tua proprietà, creane uno!",
  },
  no_weblinks: {
    EN: "No weblinks found",
    FR: "Aucun lien web trouvé",
    IT: "Nessun collegamento web trovato",
  },
  url: {
    EN: "URL",
    FR: "URL",
    IT: "URL",
  },
  open_url: {
    EN: "Open URL",
    FR: "Ouvrir l'URL",
    IT: "Apri URL",
  },
  trivia_title: {
    EN: "Trivia",
    FR: "Trivia",
    IT: "Trivia",
  },
  create_trivia: {
    EN: "Create trivia",
    FR: "Créer une trivia",
    IT: "Crea una trivia",
  },
  edit_trivia: {
    EN: "Edit trivia",
    FR: "Modifier la trivia",
    IT: "Modifica trivia",
  },
  no_trivia_subtext: {
    EN: "There is no trivia available within your property, create one!",
    FR: "Il n'y a pas de trivia disponible dans votre propriété, créez-en un !",
    IT: "Non ci sono trivia disponibili nella tua proprietà, creane una!",
  },
  no_trivia: {
    EN: "No trivia found",
    FR: "Aucune trivia trouvée",
    IT: "Nessuna trivia trovata",
  },
  surveys_title: {
    EN: "Surveys",
    FR: "Sondages",
    IT: "Sondaggi",
  },
  create_survey: {
    EN: "Create survey",
    FR: "Créer un sondage",
    IT: "Crea un sondaggio",
  },
  edit_survey: {
    EN: "Edit survey",
    FR: "Modifier le sondage",
    IT: "Modifica sondaggio",
  },
  true: {
    EN: "True",
    FR: "Vrai",
    IT: "Vero",
  },
  false: {
    EN: "False",
    FR: "Faux",
    IT: "Falso",
  },
  no_surveys_subtext: {
    EN: "There are no surveys available within your property, create one!",
    FR: "Il n'y a pas de sondages disponibles dans votre propriété, créez-en un !",
    IT: "Non ci sono sondaggi disponibili nella tua proprietà, creane uno!",
  },
  no_surveys: {
    EN: "No surveys found",
    FR: "Aucun sondage trouvé",
    IT: "Nessun sondaggio trovato",
  },
  scored_survey: {
    EN: "Is this survey scored?",
    FR: "Ce sondage est-il noté ?",
    IT: "Questo sondaggio è punteggiato?",
  },
  scored_survey_description: {
    EN: 'Enable this toggle to make this survey "scored"',
    FR: 'Activez ce commutateur pour rendre ce sondage "noté"',
    IT: 'Attiva questo interruttore per rendere questo sondaggio "punteggiato"',
  },
  question: {
    EN: "Question",
    FR: "Question",
    IT: "Domanda",
  },
  add_question_for: {
    EN: "Add a question for",
    FR: "Ajouter une question pour",
    IT: "Aggiungi una domanda per",
  },
  add_another_question: {
    EN: "Add another question",
    FR: "Ajouter une autre question",
    IT: "Aggiungi un'altra domanda",
  },
  answer: {
    EN: "Answer",
    FR: "Réponse",
    IT: "Risposta",
  },
  status_survey_subtext: {
    EN: 'Switch this toggle on to enable this survey as "active"',
    FR: 'Activez ce commutateur pour activer ce sondage en tant que "actif"',
    IT: 'Attiva questo interruttore per abilitare questo sondaggio come "attivo"',
  },
  questions: {
    EN: "Questions",
    FR: "Questions",
    IT: "Domande",
  },
  scored: {
    EN: "Scored",
    FR: "Noté",
    IT: "Punteggiato",
  },
  not_scored: {
    EN: "Not scored",
    FR: "Non noté",
    IT: "Non punteggiato",
  },
  no_survey_responses_subtext: {
    EN: "There are no responses for this survey within your property!",
    FR: "Il n'y a pas de réponses à ce sondage dans votre propriété !",
    IT: "Non ci sono risposte a questo sondaggio nella tua proprietà!",
  },
  no_survey_responses: {
    EN: "No survey responses found",
    FR: "Aucune réponse au sondage trouvée",
    IT: "Nessuna risposta al sondaggio trovata",
  },
  answered_correctly: {
    EN: "Answered correctly",
    FR: "Répondu correctement",
    IT: "Risposto correttamente",
  },
  room_frequency: {
    EN: "Room frequency",
    FR: "Fréquence de la pièce",
    IT: "Frequenza della stanza",
  },
  room_frequency_survey: {
    EN: "How many times did each room respond to this survey?",
    FR: "Combien de fois chaque pièce a-t-elle répondu à ce sondage ?",
    IT: "Quante volte ogni stanza ha risposto a questo sondaggio?",
  },
  pois_title: {
    EN: "Points of interest",
    FR: "Points d'intérêt",
    IT: "Punti di interesse",
  },
  create_poi: {
    EN: "Create point of interest",
    FR: "Créer un point d'intérêt",
    IT: "Crea un punto di interesse",
  },
  edit_poi: {
    EN: "Edit point of interest",
    FR: "Modifier le point d'intérêt",
    IT: "Modifica punto di interesse",
  },
  status_poi_subtext: {
    EN: 'Switch this toggle on to enable this point of interest as "active"',
    FR: 'Activez ce commutateur pour activer ce point d\'intérêt en tant que "actif"',
    IT: 'Attiva questo interruttore per abilitare questo punto di interesse come "attivo"',
  },
  no_pois_subtext: {
    EN: "There are no points of interest available within your property, create one!",
    FR: "Il n'y a pas de points d'intérêt disponibles dans votre propriété, créez-en un !",
    IT: "Non ci sono punti di interesse disponibili nella tua proprietà, creane uno!",
  },
  no_pois: {
    EN: "No points of interest found",
    FR: "Aucun point d'intérêt trouvé",
    IT: "Nessun punto di interesse trovato",
  },
  directions_title: {
    EN: "Directions",
    FR: "Directions",
    IT: "Indicazioni",
  },
  create_directions: {
    EN: "Create directions",
    FR: "Créer des directions",
    IT: "Crea indicazioni",
  },
  edit_global_directions: {
    EN: "Edit global directions for",
    FR: "Modifier les directions globales pour",
    IT: "Modifica indicazioni globali per",
  },
  directions_placeholder: {
    EN: "Enter general directions to",
    FR: "Entrez les directions générales vers",
    IT: "Inserisci indicazioni generali per",
  },
  update_global_directions: {
    EN: "Edit global directions",
    FR: "Modifier les directions globales",
    IT: "Modifica indicazioni globali",
  },
  update_local_directions: {
    EN: "Edit local directions",
    FR: "Modifier les directions locales",
    IT: "Modifica indicazioni locali",
  },
  local_directions_placeholder: {
    EN: "Enter local directions from",
    FR: "Entrez les directions locales de",
    IT: "Inserisci indicazioni locali da",
  },
  edit_local_directions: {
    EN: "Edit local directions for",
    FR: "Modifier les directions locales pour",
    IT: "Modifica indicazioni locali per",
  },
  vicinity_title: {
    EN: "Vicinity",
    FR: "Voisinage",
    IT: "Vicinanza",
  },
  no_no_vicinitys_subtext: {
    EN: "There are no vicinitys available within your property, create one!",
    FR: "Il n'y a pas de voisinage disponible dans votre propriété, créez-en un !",
    IT: "Non ci sono vicinanze disponibili nella tua proprietà, creane una!",
  },
  no_no_vicinitys: {
    EN: "No vicinitys found",
    FR: "Aucun voisinage trouvé",
    IT: "Nessuna vicinanza trovata",
  },
  rooms_with_directions: {
    EN: " Rooms with directions",
    FR: " Pièces avec directions",
    IT: " Stanze con indicazioni",
  },
  room_with_directions: {
    EN: " Room with directions",
    FR: " Pièce avec directions",
    IT: " Stanza con indicazioni",
  },
  webhooks_title: {
    EN: "Webhooks",
    FR: "Webhooks",
    IT: "Webhook",
  },
  create_webhook: {
    EN: "Create webhook",
    FR: "Créer un webhook",
    IT: "Crea un webhook",
  },
  edit_webhook: {
    EN: "Edit webhook",
    FR: "Modifier le webhook",
    IT: "Modifica webhook",
  },
  no_webhooks_subtext: {
    EN: "There are no webhooks available within your property, create one!",
    FR: "Il n'y a pas de webhooks disponibles dans votre propriété, créez-en un !",
    IT: "Non ci sono webhook disponibili nella tua proprietà, creane uno!",
  },
  no_webhooks: {
    EN: "No webhooks found",
    FR: "Aucun webhook trouvé",
    IT: "Nessun webhook trovato",
  },
  trigger_action: {
    EN: "Trigger action",
    FR: "Déclencher l'action",
    IT: "Attiva azione",
  },
  name_placeholder_webhook: {
    EN: "Enter a name for this webhook",
    FR: "Entrez un nom pour ce webhook",
    IT: "Inserisci un nome per questo webhook",
  },
  url_placeholder_webhook: {
    EN: "Enter a URL for this webhook",
    FR: "Entrez une URL pour ce webhook",
    IT: "Inserisci un URL per questo webhook",
  },
  url_subtext_webhook: {
    EN: 'Enter the URL for the webhook to be called when the action is triggered. Use "{{}}" to add placeholders',
    FR: "Entrez l'URL du webhook à appeler lorsque l'action est déclenchée. Utilisez \"{{}}\" pour ajouter des espaces réservés",
    IT: "Inserisci l'URL per il webhook da chiamare quando viene attivata l'azione. Usa \"{{}}\" per aggiungere spazi riservati",
  },
  method: {
    EN: "Method",
    FR: "Méthode",
    IT: "Metodo",
  },
  authentication_type: {
    EN: "Authentication type",
    FR: "Type d'authentification",
    IT: "Tipo di autenticazione",
  },
  placeholder___for_url: {
    EN: "Placeholder {{}} for URL",
    FR: "Espace réservé {{}} pour l'URL",
    IT: "Segnaposto {{}} per URL",
  },
  authentication_in: {
    EN: "Authentication in",
    FR: "Authentification dans",
    IT: "Autenticazione in",
  },
  authentication_key_name: {
    EN: "Authentication key name",
    FR: "Nom de la clé d'authentification",
    IT: "Nome chiave di autenticazione",
  },
  auth_key: {
    EN: "Authentication key",
    FR: "Clé d'authentification",
    IT: "Chiave di autenticazione",
  },
  auth_key_placeholder_webhook: {
    EN: "Enter an authentication key",
    FR: "Entrez une clé d'authentification",
    IT: "Inserisci una chiave di autenticazione",
  },
  auth_key_subtext_webhook: {
    EN: "Obtain an authentication key from the destination and enter it here. This will be sent as part of the webhook request",
    FR: "Obtenez une clé d'authentification à partir de la destination et entrez-la ici. Elle sera envoyée dans le cadre de la demande de webhook",
    IT: "Ottieni una chiave di autenticazione dalla destinazione e inseriscila qui. Questo verrà inviato come parte della richiesta webhook",
  },
  body_placeholder_webhook: {
    EN: "Enter a body for this webhook",
    FR: "Entrez un corps pour ce webhook",
    IT: "Inserisci un corpo per questo webhook",
  },
  body_subtext_webhook: {
    EN: 'Enter valid JSON to provide a template for the request body. Use "{{}}" as placeholders for dynamic values',
    FR: 'Entrez un JSON valide pour fournir un modèle pour le corps de la demande. Utilisez "{{}}" comme espaces réservés pour les valeurs dynamiques',
    IT: 'Inserisci un JSON valido per fornire un modello per il corpo della richiesta. Usa "{{}}" come segnaposto per i valori dinamici',
  },
  placeholder___for_body: {
    EN: 'Placeholder || for "{{}}"',
    FR: 'Espace réservé || pour "{{}}"',
    IT: 'Segnaposto || per "{{}}"',
  },
  status_webhook_subtext: {
    EN: 'Switch this toggle on to enable this webhook as "active"',
    FR: 'Activez ce commutateur pour activer ce webhook en tant que "actif"',
    IT: 'Attiva questo interruttore per abilitare questo webhook come "attivo"',
  },
  webhook_history: {
    EN: "Webhook history",
    FR: "Historique des webhooks",
    IT: "Cronologia webhook",
  },
  no_webhook_history_subtext: {
    EN: "There is no trigger history for this webhook!",
    FR: "Il n'y a pas d'historique de déclenchement pour ce webhook !",
    IT: "Non ci sono trigger cronologici per questo webhook!",
  },
  no_webhook_history: {
    EN: "No webhook history found",
    FR: "Aucun historique de webhook trouvé",
    IT: "Nessuna cronologia webhook trovata",
  },
  appliances_title: {
    EN: "Appliances",
    FR: "Appareils",
    IT: "Elettrodomestici",
  },
  no_appliances_subtext: {
    EN: "There are no appliances available within your property, create one!",
    FR: "Il n'y a pas d'appareils disponibles dans votre propriété, créez-en un !",
    IT: "Non ci sono elettrodomestici disponibili nella tua proprietà, creane uno!",
  },
  no_appliances: {
    EN: "No appliances found",
    FR: "Aucun appareil trouvé",
    IT: "Nessun elettrodomestico trovato",
  },
  power_off: {
    EN: "Power off",
    FR: "Éteindre",
    IT: "Spegnere",
  },
  power_on: {
    EN: "Power on",
    FR: "Allumer",
    IT: "Accendere",
  },
  forget_appliance: {
    EN: "Forget appliance",
    FR: "Oublier l'appareil",
    IT: "Dimentica l'elettrodomestico",
  },
  groups_title: {
    EN: "Groups",
    FR: "Groupes",
    IT: "Gruppi",
  },
  create_group: {
    EN: "Create group",
    FR: "Créer un groupe",
    IT: "Crea un gruppo",
  },
  edit_group: {
    EN: "Edit group",
    FR: "Modifier le groupe",
    IT: "Modifica gruppo",
  },
  no_groups_subtext: {
    EN: "There are no groups available within your property, create one!",
    FR: "Il n'y a pas de groupes disponibles dans votre propriété, créez-en un !",
    IT: "Non ci sono gruppi disponibili nella tua proprietà, creane uno!",
  },
  no_groups: {
    EN: "No groups found",
    FR: "Aucun groupe trouvé",
    IT: "Nessun gruppo trovato",
  },
  appliances: {
    EN: "Appliances",
    FR: "Appareils",
    IT: "Elettrodomestici",
  },
  appliance: {
    EN: "Appliance",
    FR: "Appareil",
    IT: "Elettrodomestico",
  },
  device: {
    EN: "Device",
    FR: "Appareil",
    IT: "Dispositivo",
  },
  catalog_title: {
    EN: "Catalog",
    FR: "Catalogue",
    IT: "Catalogo",
  },
  no_catalog_subtext: {
    EN: "There is no catalog of request options available within your property!",
    FR: "Il n'y a pas de catalogue d'options de demande disponibles dans votre propriété !",
    IT: "Non esiste un catalogo di opzioni di richiesta disponibile nella tua proprietà!",
  },
  no_catalog: {
    EN: "No catalog found",
    FR: "Aucun catalogue trouvé",
    IT: "Nessun catalogo trovato",
  },
  approved: {
    EN: "Approved",
    FR: "Approuvé",
    IT: "Approvato",
  },
  not_approved: {
    EN: "Not approved",
    FR: "Non approuvé",
    IT: "Non approvato",
  },
  save_catalog: {
    EN: "Save catalog",
    FR: "Enregistrer le catalogue",
    IT: "Salva catalogo",
  },
  availability_title: {
    EN: "Availability",
    FR: "Disponibilité",
    IT: "Disponibilità",
  },
  save_availability: {
    EN: "Save availability",
    FR: "Enregistrer la disponibilité",
    IT: "Salva disponibilità",
  },
  no_availability_subtext: {
    EN: "There is no availability of request options available within your property!",
    FR: "Il n'y a pas de disponibilité d'options de demande disponibles dans votre propriété !",
    IT: "Non esiste una disponibilità di opzioni di richiesta disponibile nella tua proprietà!",
  },
  profile_title: {
    EN: "Profile",
    FR: "Profil",
    IT: "Profilo",
  },
  save_profile: {
    EN: "Save profile",
    FR: "Enregistrer le profil",
    IT: "Salva profilo",
  },
  current_password: {
    EN: "Current password",
    FR: "Mot de passe actuel",
    IT: "Password attuale",
  },
  new_password: {
    EN: "New password",
    FR: "Nouveau mot de passe",
    IT: "Nuova password",
  },
  confirm_new_password: {
    EN: "Confirm new password",
    FR: "Confirmer le nouveau mot de passe",
    IT: "Conferma nuova password",
  },
  payment_items_title: {
    EN: "Payment items",
    FR: "Articles de paiement",
    IT: "Articoli di pagamento",
  },
  create_payment_item: {
    EN: "Create payment item",
    FR: "Créer un article de paiement",
    IT: "Crea un articolo di pagamento",
  },
  edit_payment_item: {
    EN: "Edit payment item",
    FR: "Modifier l'article de paiement",
    IT: "Modifica articolo di pagamento",
  },
  no_payment_items_subtext: {
    EN: "There are no payment items available within your property, create one!",
    FR: "Il n'y a pas d'articles de paiement disponibles dans votre propriété, créez-en un !",
    IT: "Non ci sono articoli di pagamento disponibili nella tua proprietà, creane uno!",
  },
  no_payment_items: {
    EN: "No payment items found",
    FR: "Aucun article de paiement trouvé",
    IT: "Nessun articolo di pagamento trovato",
  },
  request_option: {
    EN: "Request option",
    FR: "Option de demande",
    IT: "Opzione di richiesta",
  },
  description_payment_item_placeholder: {
    EN: "Enter a description for this payment item",
    FR: "Entrez une description pour cet article de paiement",
    IT: "Inserisci una descrizione per questo articolo di pagamento",
  },
  price: {
    EN: "Price",
    FR: "Prix",
    IT: "Prezzo",
  },
  tax: {
    EN: "Tax",
    FR: "Taxe",
    IT: "Tassa",
  },
  status_payment_item_subtext: {
    EN: 'Switch this toggle on to enable this payment item as "active"',
    FR: 'Activez ce commutateur pour activer cet article de paiement en tant que "actif"',
    IT: 'Attiva questo interruttore per abilitare questo articolo di pagamento come "attivo"',
  },
  filter: {
    EN: "Filter",
    FR: "Filtre",
    IT: "Filtro",
  },
  filters: {
    EN: "Filters",
    FR: "Filtres",
    IT: "Filtri",
  },
  logout: {
    EN: "Logout",
    FR: "Déconnexion",
    IT: "Disconnettersi",
  },
  go_to_app: {
    EN: "Go to app",
    FR: "Aller à l'application",
    IT: "Vai all'app",
  },
  feed: {
    EN: "Feed",
    FR: "Fil d'actualité",
    IT: "Feed",
  },
  insights: {
    EN: "Insights",
    FR: "Perspectives",
    IT: "Insights",
  },
  analytics: {
    EN: "Analytics",
    FR: "Analytique",
    IT: "Analytics",
  },
  log: {
    EN: "Log",
    FR: "Journal",
    IT: "Registro",
  },
  communication: {
    EN: "Communication",
    FR: "Communication",
    IT: "Comunicazione",
  },
  announcements: {
    EN: "Announcements",
    FR: "Annonces",
    IT: "Annunci",
  },
  contact_books: {
    EN: "Contact books",
    FR: "Carnets d'adresses",
    IT: "Rubriche",
  },
  calling: {
    EN: "Calling",
    FR: "Appel",
    IT: "Chiamata",
  },
  reciprocation: {
    EN: "Reciprocation",
    FR: "Réciprocité",
    IT: "Ricambi",
  },
  campaigns: {
    EN: "Campaigns",
    FR: "Campagnes",
    IT: "Campagne",
  },
  photo_albums: {
    EN: "Photo albums",
    FR: "Albums photo",
    IT: "Album fotografici",
  },
  events: {
    EN: "Events",
    FR: "Événements",
    IT: "Eventi",
  },
  services: {
    EN: "Services",
    FR: "Services",
    IT: "Servizi",
  },
  menus: {
    EN: "Menus",
    FR: "Menus",
    IT: "Menu",
  },
  newsletters: {
    EN: "Newsletters",
    FR: "Lettres d'information",
    IT: "Newsletter",
  },
  web_links: {
    EN: "Web links",
    FR: "Liens Web",
    IT: "Collegamenti web",
  },
  trivia: {
    EN: "Trivia",
    FR: "Trivia",
    IT: "Trivia",
  },
  surveys: {
    EN: "Surveys",
    FR: "Sondages",
    IT: "Sondaggi",
  },
  orientation: {
    EN: "Orientation",
    FR: "Orientation",
    IT: "Orientamento",
  },
  points_of_interest: {
    EN: "Points of interest",
    FR: "Points d'intérêt",
    IT: "Punti di interesse",
  },
  vicinity: {
    EN: "Vicinity",
    FR: "Voisinage",
    IT: "Vicinanza",
  },
  integration: {
    EN: "Integration",
    FR: "Intégration",
    IT: "Integrazione",
  },
  configuration: {
    EN: "Configuration",
    FR: "Configuration",
    IT: "Configurazione",
  },
  history: {
    EN: "History",
    FR: "Histoire",
    IT: "Storia",
  },
  smart_control: {
    EN: "Smart control",
    FR: "Contrôle intelligent",
    IT: "Controllo intelligente",
  },
  groups: {
    EN: "Groups",
    FR: "Groupes",
    IT: "Gruppi",
  },
  payment: {
    EN: "Payment",
    FR: "Paiement",
    IT: "Pagamento",
  },
  property: {
    EN: "Property",
    FR: "Propriété",
    IT: "Proprietà",
  },
  catalog: {
    EN: "Catalog",
    FR: "Catalogue",
    IT: "Catalogo",
  },
  settings: {
    EN: "Settings",
    FR: "Paramètres",
    IT: "Impostazioni",
  },
  profile: {
    EN: "Profile",
    FR: "Profil",
    IT: "Profilo",
  },
  overview: {
    EN: "Overview",
    FR: "Aperçu",
    IT: "Panoramica",
  },
  templates: {
    EN: "Templates",
    FR: "Modèles",
    IT: "Modelli",
  },
  complete: {
    EN: "Complete",
    FR: "Compléter",
    IT: "Completa",
  },
  in_progress: {
    EN: "In progress",
    FR: "En cours",
    IT: "In corso",
  },
  created: {
    EN: "Created",
    FR: "Créé",
    IT: "Creato",
  },
  request: {
    EN: "Request",
    FR: "Demande",
    IT: "Richiesta",
  },
  detail: {
    EN: "Detail",
    FR: "Détail",
    IT: "Dettaglio",
  },
  quantity: {
    EN: "Quantity",
    FR: "Quantité",
    IT: "Quantità",
  },
  edit_room: {
    EN: "Edit room",
    FR: "Modifier la pièce",
    IT: "Modifica stanza",
  },
  clear: {
    EN: "Clear",
    FR: "Effacer",
    IT: "Pulisci",
  },
  activity: {
    EN: "Activity",
    FR: "Activité",
    IT: "Attività",
  },
  associated_user: {
    EN: "Associated user",
    FR: "Utilisateur associé",
    IT: "Utente associato",
  },
  details: {
    EN: "Details",
    FR: "Détails",
    IT: "Dettagli",
  },
  enable: {
    EN: "Enable",
    FR: "Activer",
    IT: "Abilitare",
  },
  disable: {
    EN: "Disable",
    FR: "Désactiver",
    IT: "Disabilitare",
  },
  timestamp: {
    EN: "Timestamp",
    FR: "Horodatage",
    IT: "Timestamp",
  },
  correct: {
    EN: "Correct",
    FR: "Correct",
    IT: "Corretto",
  },
  action: {
    EN: "Action",
    FR: "Action",
    IT: "Azione",
  },
  sent_body: {
    EN: "Sent body",
    FR: "Corps envoyé",
    IT: "Corpo inviato",
  },
  response_on_send: {
    EN: "Response on send",
    FR: "Réponse à l'envoi",
    IT: "Risposta all'invio",
  },
  received_body: {
    EN: "Received body",
    FR: "Corps reçu",
    IT: "Corpo ricevuto",
  },
  change: {
    EN: "Change",
    FR: "Changer",
    IT: "Cambiare",
  },
  rooms_contact_book_subtext: {
    EN: "Select the rooms to apply this contact book to",
    FR: "Sélectionnez les pièces auxquelles appliquer ce carnet d'adresses",
    IT: "Seleziona le stanze a cui applicare questa rubrica",
  },
  confirm_forget_appliance: {
    EN: "Are you sure you want to forget this appliance? This action cannot be undone",
    FR: "Êtes-vous sûr de vouloir oublier cet appareil ? Cette action ne peut pas être annulée",
    IT: "Sei sicuro di voler dimenticare questo elettrodomestico? Questa azione non può essere annullata",
  },
  request_email_notification_loading: {
    EN: "Sending request notification update, do not refresh or close this window...",
    FR: "Envoi de la mise à jour de la notification de demande, ne pas actualiser ou fermer cette fenêtre...",
    IT: "Invio dell'aggiornamento della notifica di richiesta, non aggiornare o chiudere questa finestra...",
  },
  request_email_notification_failed: {
    EN: "Failed to update request notification, try again or contact support",
    FR: "Échec de la mise à jour de la notification de demande, réessayez ou contactez le support",
    IT: "Impossibile aggiornare la notifica di richiesta, riprova o contatta il supporto",
  },
  request_email_notification_success: {
    EN: "Successfully updated request notification, you can close this window now",
    FR: "Mise à jour réussie de la notification de demande, vous pouvez maintenant fermer cette fenêtre",
    IT: "Notifica di richiesta aggiornata correttamente, puoi chiudere questa finestra ora",
  },
  request_email_notification_null: {
    EN: "Unable to find this request, try again or contact support",
    FR: "Impossible de trouver cette demande, réessayez ou contactez le support",
    IT: "Impossibile trovare questa richiesta, riprova o contatta il supporto",
  },
  payment_confirmation_loading: {
    EN: "Updating transaction, do not refresh or close this window...",
    FR: "Mise à jour de la transaction, ne pas actualiser ou fermer cette fenêtre...",
    IT: "Aggiornamento della transazione, non aggiornare o chiudere questa finestra...",
  },
  payment_confirmation_failed: {
    EN: "Failed to update transaction, try refreshing this window or contact support with your receipt",
    FR: "Impossible de mettre à jour la transaction, essayez de rafraîchir cette fenêtre ou contactez le support avec votre reçu",
    IT: "Impossibile aggiornare la transazione, prova a ricaricare questa finestra o contatta il supporto con la ricevuta",
  },
  payment_confirmation_success: {
    EN: "Transaction complete, you can close this window now",
    FR: "Transaction terminée, vous pouvez maintenant fermer cette fenêtre",
    IT: "Transazione completata, puoi chiudere questa finestra ora",
  },
  payment_confirmation_expired: {
    EN: "Link expired, you can close this window now",
    FR: "Lien expiré, vous pouvez maintenant fermer cette fenêtre",
    IT: "Link scaduto, puoi chiudere questa finestra ora",
  },
  payment_confirmation_null: {
    EN: "Unable to find this transaction, try refreshing this window or contact support with your receipt",
    FR: "Impossible de trouver cette transaction, essayez de rafraîchir cette fenêtre ou contactez le support avec votre reçu",
    IT: "Impossibile trovare questa transazione, prova a ricaricare questa finestra o contatta il supporto con la ricevuta",
  },
  payment_cancellation_loading: {
    EN: "Updating transaction, do not refresh or close this window...",
    FR: "Mise à jour de la transaction, ne pas actualiser ou fermer cette fenêtre...",
    IT: "Aggiornamento della transazione, non aggiornare o chiudere questa finestra...",
  },
  payment_cancellation_failed: {
    EN: "Failed to update transaction, try refreshing this window or contact support with your receipt",
    FR: "Impossible de mettre à jour la transaction, essayez de rafraîchir cette fenêtre ou contactez le support avec votre reçu",
    IT: "Impossibile aggiornare la transazione, prova a ricaricare questa finestra o contatta il supporto con la ricevuta",
  },
  payment_cancellation_success: {
    EN: "Transaction successfully cancelled, you can close this window now",
    FR: "Transaction annulée avec succès, vous pouvez maintenant fermer cette fenêtre",
    IT: "Transazione annullata con successo, puoi chiudere questa finestra ora",
  },
  payment_cancellation_null: {
    EN: "Unable to find this transaction, try refreshing this window or contact support with your receipt",
    FR: "Impossible de trouver cette transaction, essayez de rafraîchir cette fenêtre ou contactez le support avec votre reçu",
    IT: "Impossibile trovare questa transazione, prova a ricaricare questa finestra o contatta il supporto con la ricevuta",
  },
  payment_cancellation_expired: {
    EN: "Link expired, you can close this window now",
    FR: "Lien expiré, vous pouvez maintenant fermer cette fenêtre",
    IT: "Link scaduto, puoi chiudere questa finestra ora",
  },
  item_image: {
    EN: "Item image",
    FR: "Image de l'article",
    IT: "Immagine dell'articolo",
  },
  event_link: {
    EN: "Event link",
    FR: "Lien de l'événement",
    IT: "Link dell'evento",
  },
  image: {
    EN: "Image",
    FR: "Image",
    IT: "Immagine",
  },
  description_weblink_placeholder: {
    EN: "Enter a description for this web link",
    FR: "Entrez une description pour ce lien Web",
    IT: "Inserisci una descrizione per questo collegamento web",
  },
  weblink_type_subtext: {
    EN: "Select the type of web link",
    FR: "Sélectionnez le type de lien Web",
    IT: "Seleziona il tipo di collegamento web",
  },
  tasks_title: {
    EN: "Tasks",
    FR: "Tâches",
    IT: "Compiti",
  },
  create_task: {
    EN: "Create task",
    FR: "Créer une tâche",
    IT: "Crea un compito",
  },
  edit_task: {
    EN: "Edit task",
    FR: "Modifier la tâche",
    IT: "Modifica compito",
  },
  tasks: {
    EN: "Tasks",
    FR: "Tâches",
    IT: "Compiti",
  },
  manage: {
    EN: "Manage",
    FR: "Gérer",
    IT: "Gestire",
  },
  logs: {
    EN: "Logs",
    FR: "Journaux",
    IT: "Registri",
  },
  task_frequency_choice: {
    EN: "What period should this be repeated over?",
    FR: "Sur quelle période cela doit-il être répété ?",
    IT: "Su quale periodo dovrebbe essere ripetuto?",
  },
  task_frequency_value: {
    EN: "How many periods should elapse before this task needs to be completed again?",
    FR: "Combien de périodes doivent s'écouler avant que cette tâche ne doive être à nouveau terminée ?",
    IT: "Quanti periodi devono trascorrere prima che questo compito debba essere completato nuovamente?",
  },
  room_remaining: {
    EN: "Room remaining",
    FR: "Pièce restante",
    IT: "Stanza rimanente",
  },
  rooms_remaining: {
    EN: "Rooms remaining",
    FR: "Pièces restantes",
    IT: "Stanze rimanenti",
  },
  task_logs_title: {
    EN: "Task logs",
    FR: "Journaux des tâches",
    IT: "Log delle attività",
  },
  tasks_manage_title: {
    EN: "Manage tasks",
    FR: "Gérer les tâches",
    IT: "Gestisci attività",
  },
  task: {
    EN: "Task",
    FR: "Tâche",
    IT: "Compito",
  },
  user: {
    EN: "User",
    FR: "Utilisateur",
    IT: "Utente",
  },
  completion_rate_chart_title: {
    EN: "Completion rate",
    FR: "Taux de réalisation",
    IT: "Tasso di completamento",
  },
  completion_rate_chart_subtitle: {
    EN: "What percentage of rooms have completed their tasks?",
    FR: "Quel pourcentage de pièces ont terminé leurs tâches ?",
    IT: "Quale percentuale di stanze ha completato i propri compiti?",
  },
  complete_vs_incomplete_chart_title: {
    EN: "Complete vs Incomplete",
    FR: "Tâches complètes vs incomplètes",
    IT: "Compiti completi vs incompleti",
  },
  complete_vs_incomplete_chart_subtitle: {
    EN: "How many tasks are complete vs incomplete?",
    FR: "Combien de tâches sont complètes par rapport à incomplètes ?",
    IT: "Quanti compiti sono completi rispetto a incompleti?",
  },
  outstanding_tasks_chart_title: {
    EN: "Outstanding tasks",
    FR: "Tâches en cours",
    IT: "Compiti eccezionali",
  },
  outstanding_tasks_chart_subtitle: {
    EN: "How many tasks are outstanding?",
    FR: "Combien de tâches sont en cours ?",
    IT: "Quanti compiti sono eccezionali?",
  },
  edit: {
    EN: "Edit",
    FR: "Modifier",
    IT: "Modifica",
  },
  delete: {
    EN: "Delete",
    FR: "Supprimer",
    IT: "Elimina",
  },
  delete_log: {
    EN: "Delete log",
    FR: "Supprimer le journal",
    IT: "Elimina registro",
  },
  delete_logs_confirmation: {
    EN: "Are you sure you want to delete the selected logs? This action cannot be undone",
    FR: "Êtes-vous sûr de vouloir supprimer les journaux sélectionnés ? Cette action ne peut pas être annulée",
    IT: "Sei sicuro di voler eliminare i registri selezionati? Questa azione non può essere annullata",
  },
  delete_logs: {
    EN: "Delete logs",
    FR: "Supprimer les journaux",
    IT: "Elimina registri",
  },
  edit_task_log: {
    EN: "Edit task log",
    FR: "Modifier le journal de tâche",
    IT: "Modifica registro attività",
  },
  no_tasks: {
    EN: "No tasks found",
    FR: "Aucune tâche trouvée",
    IT: "Nessuna attività trovata",
  },
  no_tasks_subtext: {
    EN: "There are no tasks available within your property, create one!",
    FR: "Il n'y a pas de tâches disponibles dans votre propriété, créez-en une !",
    IT: "Non ci sono attività disponibili nella tua proprietà, creane una!",
  },
  overview_title: {
    EN: "Overview",
    FR: "Aperçu",
    IT: "Panoramica",
  },
  rooms_with_devices: {
    EN: "Rooms with devices",
    FR: "Pièces avec appareils",
    IT: "Stanze con dispositivi",
  },
  oversight_overview_rooms_with_devices_subtext: {
    EN: "How many rooms have devices associated to them?",
    FR: "Combien de pièces ont des appareils associés à elles ?",
    IT: "Quante stanze hanno dispositivi associati a loro?",
  },
  number_requests: {
    EN: "Number of requests",
    FR: "Nombre de demandes",
    IT: "Numero di richieste",
  },
  oversight_overview_number_requests_subtext: {
    EN: "How many requests were made by users?",
    FR: "Combien de demandes ont été faites par les utilisateurs ?",
    IT: "Quante richieste sono state fatte dagli utenti?",
  },
  rooms_with_requests: {
    EN: "Rooms with requests",
    FR: "Pièces avec demandes",
    IT: "Stanze con richieste",
  },
  oversight_overview_rooms_with_requests_subtext: {
    EN: "How many rooms have made requests?",
    FR: "Combien de pièces ont fait des demandes ?",
    IT: "Quante stanze hanno fatto richieste?",
  },
  actionable_request_status: {
    EN: "Actionable request status",
    FR: "Statut de demande actionable",
    IT: "Stato richiesta eseguibile",
  },
  oversight_overview_actionable_request_status_subtext: {
    EN: "What were the statuses of the actionable requests?",
    FR: "Quels étaient les statuts des demandes exécutables ?",
    IT: "Quali erano gli stati delle richieste eseguibili?",
  },
  content_type_count: {
    EN: "Content type count",
    FR: "Nombre de types de contenu",
    IT: "Conteggio dei tipi di contenuto",
  },
  oversight_overview_content_type_count_subtext: {
    EN: "What types of content were created?",
    FR: "Quels types de contenu ont été créés ?",
    IT: "Quali tipi di contenuto sono stati creati?",
  },
  active_users: {
    EN: "Active users",
    FR: "Utilisateurs actifs",
    IT: "Utenti attivi",
  },
  oversight_overview_active_users_subtext: {
    EN: "How many users were active in the dashboard?",
    FR: "Combien d'utilisateurs étaient actifs dans le tableau de bord ?",
    IT: "Quanti utenti erano attivi nel dashboard?",
  },
  devices_online: {
    EN: "Devices online",
    FR: "Appareils en ligne",
    IT: "Dispositivi online",
  },
  oversight_overview_devices_online_subtext: {
    EN: "How many devices are currently Online vs. Offine?",
    FR: "Combien d'appareils sont actuellement en ligne par rapport à hors ligne ?",
    IT: "Quanti dispositivi sono attualmente Online vs. Offine?",
  },
  payment_status_count: {
    EN: "Payment status count",
    FR: "Nombre de statuts de paiement",
    IT: "Conteggio dello stato del pagamento",
  },
  oversight_overview_payment_status_count_subtext: {
    EN: "What are the statuses of the payment transactions?",
    FR: "Quels sont les statuts des transactions de paiement ?",
    IT: "Quali sono gli stati delle transazioni di pagamento?",
  },
  payment_total_amount: {
    EN: "Total payment amount",
    FR: "Montant total du paiement",
    IT: "Importo totale del pagamento",
  },
  oversight_overview_payment_total_amount_subtext: {
    EN: "How much was successfully processed by audico?",
    FR: "Combien a été traité avec succès par audico ?",
    IT: "Quanto è stato elaborato con successo da audico?",
  },
  oversight_feed_category_count_subtext: {
    EN: "What categories of requests were made?",
    FR: "Quelles catégories de demandes ont été faites ?",
    IT: "Quali categorie di richieste sono state fatte?",
  },
  oversight_feed_property_count_subtext: {
    EN: "How many requests did each property make?",
    FR: "Combien de demandes chaque propriété a-t-elle faites ?",
    IT: "Quante richieste ha fatto ciascuna proprietà?",
  },
  oversight_feed_room_count_subtext: {
    EN: "How many requests did each room make?",
    FR: "Combien de demandes chaque pièce a-t-elle faites ?",
    IT: "Quante richieste ha fatto ciascuna stanza?",
  },
  announcement_time_series: {
    EN: "Announcement time series",
    FR: "Série temporelle des annonces",
    IT: "Serie temporale degli annunci",
  },
  oversight_communication_time_series_subtext: {
    EN: "How many announcements were sent over time?",
    FR: "Combien d'annonces ont été envoyées au fil du temps ?",
    IT: "Quanti annunci sono stati inviati nel tempo?",
  },
  oversight_communication_property_count_subtext: {
    EN: "How many announcements were sent by each property?",
    FR: "Combien d'annonces ont été envoyées par chaque propriété ?",
    IT: "Quanti annunci sono stati inviati da ciascuna proprietà?",
  },
  oversight_communication_room_count_subtext: {
    EN: "How many announcements were sent by each room?",
    FR: "Combien d'annonces ont été envoyées par chaque pièce ?",
    IT: "Quanti annunci sono stati inviati da ciascuna stanza?",
  },
  oversight_devices_property_count_subtext: {
    EN: "How many devices are in each property?",
    FR: "Combien d'appareils sont dans chaque propriété ?",
    IT: "Quanti dispositivi ci sono in ciascuna proprietà?",
  },
  devices_in_rooms: {
    EN: "Devices in rooms",
    FR: "Appareils dans les pièces",
    IT: "Dispositivi nelle stanze",
  },
  oversight_devices_in_rooms_subtext: {
    EN: "How many devices are associated to rooms?",
    FR: "Combien d'appareils sont associés aux pièces ?",
    IT: "Quanti dispositivi sono associati alle stanze?",
  },
  content_time_series: {
    EN: "Content time series",
    FR: "Série temporelle du contenu",
    IT: "Serie temporale del contenuto",
  },
  oversight_content_time_series_subtext: {
    EN: "How much content was created over time?",
    FR: "Combien de contenu a été créé au fil du temps ?",
    IT: "Quanto contenuto è stato creato nel tempo?",
  },
  oversight_content_type_count_subtext: {
    EN: "How much of each content type was created?",
    FR: "Combien de chaque type de contenu a été créé ?",
    IT: "Quanto di ciascun tipo di contenuto è stato creato?",
  },
  oversight_content_property_count_subtext: {
    EN: "How much content was created in each property?",
    FR: "Combien de contenu a été créé dans chaque propriété ?",
    IT: "Quanto contenuto è stato creato in ciascuna proprietà?",
  },
  oversight_content_activity_count_subtext: {
    EN: "How much activity was logged for the content created?",
    FR: "Combien d'activité a été enregistrée pour le contenu créé ?",
    IT: "Quanta attività è stata registrata per il contenuto creato?",
  },
  log_time_series: {
    EN: "Log time series",
    FR: "Série temporelle du journal",
    IT: "Serie temporale del registro",
  },
  oversight_log_time_series_subtext: {
    EN: "How many logs were created over time?",
    FR: "Combien de journaux ont été créés au fil du temps ?",
    IT: "Quanti registri sono stati creati nel tempo?",
  },
  undone_count: {
    EN: "Undone count",
    FR: "Nombre d'annulations",
    IT: "Conteggio annullato",
  },
  oversight_log_undone_count_subtext: {
    EN: "How many logs were undone?",
    FR: "Combien de journaux ont été annulés ?",
    IT: "Quanti registri sono stati annullati?",
  },
  activity_count: {
    EN: "Activity count",
    FR: "Nombre d'activités",
    IT: "Conteggio attività",
  },
  oversight_log_activity_count_subtext: {
    EN: "How many activities were recorded against the logs?",
    FR: "Combien d'activités ont été enregistrées contre les journaux ?",
    IT: "Quante attività sono state registrate contro i registri?",
  },
  user_count: {
    EN: "User count",
    FR: "Nombre d'utilisateurs",
    IT: "Conteggio utenti",
  },
  oversight_log_user_count_subtext: {
    EN: "How many logs were created by each user?",
    FR: "Combien de journaux ont été créés par chaque utilisateur ?",
    IT: "Quanti registri sono stati creati da ciascun utente?",
  },
  status_change_count: {
    EN: "Status change count",
    FR: "Nombre de changements de statut",
    IT: "Conteggio cambiamento di stato",
  },
  oversight_log_status_change_count_subtext: {
    EN: "How many status changes occurred with the logs?",
    FR: "Combien de changements de statut se sont produits avec les journaux ?",
    IT: "Quanti cambiamenti di stato sono avvenuti con i registri?",
  },
  oversight_orientation_time_series: {
    EN: "Orientation time series",
    FR: "Série temporelle d'orientation",
    IT: "Serie temporale di orientamento",
  },
  oversight_orientation_time_series_subtext: {
    EN: "When points of interest were created within the date range",
    FR: "Quand les points d'intérêt ont été créés dans la plage de dates",
    IT: "Quando i punti di interesse sono stati creati nell'intervallo di date",
  },
  oversight_orientation_property_count_subtext: {
    EN: "How many points of interest exist within each property?",
    FR: "Combien de points d'intérêt existent dans chaque propriété ?",
    IT: "Quanti punti di interesse esistono in ciascuna proprietà?",
  },
  oversight_orientation_category_count_subtext: {
    EN: "What category of points of interest have been created?",
    FR: "Quelle catégorie de points d'intérêt a été créée ?",
    IT: "Quale categoria di punti di interesse è stata creata?",
  },
  oversight_orientation_type_count_subtext: {
    EN: "What type of points of interest have been created?",
    FR: "Quel type de points d'intérêt a été créé ?",
    IT: "Quale tipo di punti di interesse è stato creato?",
  },
  oversight_orientation_directions_from_count_subtext: {
    EN: "Where were the directions created from?",
    FR: "D'où les directions ont-elles été créées ?",
    IT: "Da dove sono state create le indicazioni?",
  },
  directions_from_count: {
    EN: "Directions from count",
    FR: "Nombre de directions de",
    IT: "Conteggio indicazioni da",
  },
  webhook_history_time_series: {
    EN: "Webhook history time series",
    FR: "Série temporelle de l'historique des webhooks",
    IT: "Serie temporale della cronologia dei webhook",
  },
  oversight_integration_time_series_subtext: {
    EN: "How many webhook invocations were made over time?",
    FR: "Combien d'invocations de webhook ont été faites au fil du temps ?",
    IT: "Quante invocazioni di webhook sono state fatte nel tempo?",
  },
  oversight_integration_property_count_subtext: {
    EN: "How many webhooks were invoked for each property?",
    FR: "Combien de webhooks ont été invoqués pour chaque propriété ?",
    IT: "Quanti webhook sono stati invocati per ciascuna proprietà?",
  },
  action_count: {
    EN: "Action count",
    FR: "Nombre d'actions",
    IT: "Conteggio azioni",
  },
  oversight_integration_action_count_subtext: {
    EN: "How many webhooks of different actions exist?",
    FR: "Combien de webhooks d'actions différentes existent ?",
    IT: "Quanti webhook di azioni diverse esistono?",
  },
  entity_count: {
    EN: "Entity count",
    FR: "Nombre d'entités",
    IT: "Conteggio entità",
  },
  oversight_integration_entity_count_subtext: {
    EN: "How many integration entities exist?",
    FR: "Combien d'entités d'intégration existent ?",
    IT: "Quante entità di integrazione esistono?",
  },
  history_status_count: {
    EN: "History status count",
    FR: "Nombre de statuts d'historique",
    IT: "Conteggio stato cronologia",
  },
  oversight_integration_history_status_count_subtext: {
    EN: "What are the statuses of the webhook history?",
    FR: "Quels sont les statuts de l'historique des webhooks ?",
    IT: "Quali sono gli stati della cronologia dei webhook?",
  },
  connectivity: {
    EN: "Connectivity",
    FR: "Connectivité",
    IT: "Connettività",
  },
  oversight_sc_connectivity_subtext: {
    EN: "How many appliances are online?",
    FR: "Combien d'appareils sont en ligne ?",
    IT: "Quanti elettrodomestici sono online?",
  },
  oversight_sc_property_count_subtext: {
    EN: "How many appliances are in each property?",
    FR: "Combien d'appareils sont dans chaque propriété ?",
    IT: "Quanti elettrodomestici ci sono in ciascuna proprietà?",
  },
  power: {
    EN: "Power",
    FR: "Puissance",
    IT: "Potenza",
  },
  oversight_sc_power_subtext: {
    EN: "How many appliances are powered On vs Off?",
    FR: "Combien d'appareils sont allumés par rapport à éteints ?",
    IT: "Quanti elettrodomestici sono accesi vs spenti?",
  },
  oversight_sc_type_count_subtext: {
    EN: "What types of appliances are there?",
    FR: "Quels types d'appareils y a-t-il ?",
    IT: "Quali tipi di elettrodomestici ci sono?",
  },
  oversight_sc_model_count_subtext: {
    EN: "What are the models of the appliances?",
    FR: "Quels sont les modèles des appareils ?",
    IT: "Quali sono i modelli degli elettrodomestici?",
  },
  room_count: {
    EN: "Room count",
    FR: "Nombre de pièces",
    IT: "Conteggio stanze",
  },
  oversight_sc_room_count_subtext: {
    EN: "How many appliances and devices exist in each room?",
    FR: "Combien d'appareils et de dispositifs existent dans chaque pièce ?",
    IT: "Quanti elettrodomestici e dispositivi esistono in ciascuna stanza?",
  },
  room_with_appliances_count: {
    EN: "Room with appliances count",
    FR: "Nombre de pièces avec appareils",
    IT: "Conteggio stanze con elettrodomestici",
  },
  oversight_sc_room_with_appliances_count_subtext: {
    EN: "How many rooms have appliances associated to them?",
    FR: "Combien de pièces ont des appareils associés à elles ?",
    IT: "Quante stanze hanno elettrodomestici associati a loro?",
  },
  group_count: {
    EN: "Group count",
    FR: "Nombre de groupes",
    IT: "Conteggio gruppo",
  },
  oversight_sc_group_count_subtext: {
    EN: "How many appliance groups exist for each property?",
    FR: "Combien de groupes d'appareils existent pour chaque propriété ?",
    IT: "Quanti gruppi di elettrodomestici esistono per ciascuna proprietà?",
  },
  group_size: {
    EN: "Group size",
    FR: "Taille du groupe",
    IT: "Dimensione del gruppo",
  },
  oversight_sc_group_size_subtext: {
    EN: "What is the size of all groups by property?",
    FR: "Quelle est la taille de tous les groupes par propriété ?",
    IT: "Qual è la dimensione di tutti i gruppi per proprietà?",
  },
  tasks_time_series: {
    EN: "Task log time series",
    FR: "Série temporelle du journal de tâche",
    IT: "Serie temporale del registro attività",
  },
  oversight_tasks_time_series_subtext: {
    EN: "How many logs were recorded against tasks over time?",
    FR: "Combien de journaux ont été enregistrés par rapport aux tâches au fil du temps ?",
    IT: "Quanti registri sono stati registrati rispetto ai compiti nel tempo?",
  },
  log_task_count: {
    EN: "Task log count",
    FR: "Nombre de journaux de tâches",
    IT: "Conteggio registro attività",
  },
  oversight_tasks_log_task_count_subtext: {
    EN: "How many logs were recorded against each task?",
    FR: "Combien de journaux ont été enregistrés par rapport à chaque tâche ?",
    IT: "Quanti registri sono stati registrati rispetto a ciascun compito?",
  },
  log_profile_count: {
    EN: "Profile log count",
    FR: "Nombre de journaux de profil",
    IT: "Conteggio registro profilo",
  },
  oversight_tasks_log_profile_count_subtext: {
    EN: "How many logs did each staff member create against tasks?",
    FR: "Combien de journaux chaque membre du personnel a-t-il créés par rapport aux tâches ?",
    IT: "Quanti registri ha creato ciascun membro del personale rispetto ai compiti?",
  },
  log_room_count: {
    EN: "Room log count",
    FR: "Nombre de journaux de pièce",
    IT: "Conteggio registro stanza",
  },
  oversight_tasks_log_room_count_subtext: {
    EN: "How many logs were recorded against each room?",
    FR: "Combien de journaux ont été enregistrés par rapport à chaque pièce ?",
    IT: "Quanti registri sono stati registrati rispetto a ciascuna stanza?",
  },
  log_status_count: {
    EN: "Log status count",
    FR: "Nombre de statuts de journal",
    IT: "Conteggio stato registro",
  },
  oversight_tasks_log_status_count_subtext: {
    EN: "What are the statuses of the task logs?",
    FR: "Quels sont les statuts des journaux de tâches ?",
    IT: "Quali sono gli stati dei registri dei compiti?",
  },
  task_status_count: {
    EN: "Task status count",
    FR: "Nombre de statuts de tâche",
    IT: "Conteggio stato compito",
  },
  oversight_tasks_task_status_count_subtext: {
    EN: "What are the statuses of the tasks?",
    FR: "Quels sont les statuts des tâches ?",
    IT: "Quali sono gli stati dei compiti?",
  },
  oversight_tasks_task_category_count_subtext: {
    EN: "What are the categories of the tasks?",
    FR: "Quelles sont les catégories des tâches ?",
    IT: "Quali sono le categorie dei compiti?",
  },
  frequency_count: {
    EN: "Frequency count",
    FR: "Nombre de fréquences",
    IT: "Conteggio frequenza",
  },
  oversight_tasks_task_frequency_count_subtext: {
    EN: "What are the frequencies for the tasks?",
    FR: "Quelles sont les fréquences pour les tâches ?",
    IT: "Quali sono le frequenze per i compiti?",
  },
  oversight_tasks_task_property_rooms_count_subtext: {
    EN: "How many rooms have assigned tasks for each property?",
    FR: "Combien de pièces ont des tâches assignées pour chaque propriété ?",
    IT: "Quante stanze hanno compiti assegnati per ciascuna proprietà?",
  },
  users: {
    EN: "Users",
    FR: "Utilisateurs",
    IT: "Utenti",
  },
  login_time_series: {
    EN: "User login time series",
    FR: "Série temporelle de connexion de l'utilisateur",
    IT: "Serie temporale di accesso dell'utente",
  },
  oversight_login_time_series_subtext: {
    EN: "When did users login to the dashboard over time?",
    FR: "Quand les utilisateurs se sont-ils connectés au tableau de bord au fil du temps ?",
    IT: "Quando gli utenti hanno effettuato l'accesso al dashboard nel tempo?",
  },
  users_active_count: {
    EN: "Active users count",
    FR: "Nombre d'utilisateurs actifs",
    IT: "Conteggio utenti attivi",
  },
  oversight_users_active_count_subtext: {
    EN: "How many times did each user login?",
    FR: "Combien de fois chaque utilisateur s'est-il connecté ?",
    IT: "Quante volte ha effettuato l'accesso ciascun utente?",
  },
  new_users_count: {
    EN: "New users count",
    FR: "Nombre de nouveaux utilisateurs",
    IT: "Conteggio nuovi utenti",
  },
  oversight_new_users_count_subtext: {
    EN: "How many new users were created by each property?",
    FR: "Combien de nouveaux utilisateurs ont été créés par chaque propriété ?",
    IT: "Quanti nuovi utenti sono stati creati da ciascuna proprietà?",
  },
  users_active_by_property_count: {
    EN: "Active users by property count",
    FR: "Nombre d'utilisateurs actifs par propriété",
    IT: "Conteggio utenti attivi per proprietà",
  },
  oversight_users_active_by_property_count_subtext: {
    EN: "How many users have been active within each property?",
    FR: "Combien d'utilisateurs ont été actifs dans chaque propriété ?",
    IT: "Quanti utenti sono stati attivi in ciascuna proprietà?",
  },
  type_count: {
    EN: "Type count",
    FR: "Nombre de types",
    IT: "Conteggio tipo",
  },
  oversight_devices_type_count_subtext: {
    EN: "How many devices of each type are there?",
    FR: "Combien d'appareils de chaque type y a-t-il ?",
    IT: "Quanti dispositivi di ciascun tipo ci sono?",
  },
  model_count: {
    EN: "Model count",
    FR: "Nombre de modèles",
    IT: "Conteggio modello",
  },
  oversight_devices_model_count_subtext: {
    EN: "How many devices of each model are there?",
    FR: "Combien d'appareils de chaque modèle y a-t-il ?",
    IT: "Quanti dispositivi di ciascun modello ci sono?",
  },
  category_count: {
    EN: "Category count",
    FR: "Nombre de catégories",
    IT: "Conteggio categoria",
  },
  property_count: {
    EN: "Property count",
    FR: "Nombre de propriétés",
    IT: "Conteggio proprietà",
  },
  availability_count: {
    EN: "Availability count",
    FR: "Nombre de disponibilités",
    IT: "Conteggio disponibilità",
  },
  oversight_orientation_availability_count_subtext: {
    EN: "What availability has been chosen for points of interest?",
    FR: "Quelle disponibilité a été choisie pour les points d'intérêt ?",
    IT: "Quale disponibilità è stata scelta per i punti di interesse?",
  },
  oversight_orientation_status_count_subtext: {
    EN: "What are the statuses of the points of interest?",
    FR: "Quels sont les statuts des points d'intérêt ?",
    IT: "Quali sono gli stati dei punti di interesse?",
  },
  status_count: {
    EN: "Status count",
    FR: "Nombre de statuts",
    IT: "Conteggio stato",
  },
  poi_with_directions: {
    EN: "Points of interest with directions",
    FR: "Points d'intérêt avec directions",
    IT: "Punti di interesse con indicazioni",
  },
  oversight_orientation_poi_with_directions_subtext: {
    EN: "How many points of interest have directions?",
    FR: "Combien de points d'intérêt ont des directions ?",
    IT: "Quanti punti di interesse hanno indicazioni?",
  },
  prompts_title: {
    EN: "Prompts",
    FR: "Prompts",
    IT: "Prompts",
  },
  create_prompt: {
    EN: "Create prompt",
    FR: "Créer un prompt",
    IT: "Crea un prompt",
  },
  showcase: {
    EN: "Showcase",
    FR: "Vitrine",
    IT: "Vetrina",
  },
  showcase_prompt_subtext: {
    EN: "Do you want this prompt to be showcased?",
    FR: "Voulez-vous que ce prompt soit mis en avant ?",
    IT: "Vuoi che questo prompt sia messo in mostra?",
  },
  callback_method: {
    EN: "Callback method",
    FR: "Méthode de rappel",
    IT: "Metodo di richiamata",
  },
  callback_body_placeholder_prompts: {
    EN: "Enter the body of the callback",
    FR: "Entrez le corps du rappel",
    IT: "Inserisci il corpo della richiamata",
  },
  callback_body_subtext_prompts: {
    EN: "Enter the body of the callback",
    FR: "Entrez le corps du rappel",
    IT: "Inserisci il corpo della richiamata",
  },
  third_party: {
    EN: "Third party",
    FR: "Tiers",
    IT: "Terze parti",
  },
  prompts: {
    EN: "Prompts",
    FR: "Prompts",
    IT: "Prompts",
  },
  callback_url: {
    EN: "Callback URL",
    FR: "URL de rappel",
    IT: "URL di richiamata",
  },
  callback_target: {
    EN: "Callback target",
    FR: "Cible de rappel",
    IT: "Target di richiamata",
  },
  callback_target_subtext: {
    EN: "Will this prompt trigger an \"audico\" request or one from another destination?",
    FR: "Ce prompt déclenchera-t-il une demande \"audico\" ou une autre destination ?",
    IT: "Questo prompt attiverà una richiesta \"audico\" o una da un'altra destinazione?",
  },
  audico: {
    EN: "audico",
    FR: "audico",
    IT: "audico",
  },
  other_destination: {
    EN: "Other destination",
    FR: "Autre destination",
    IT: "Altra destinazione",
  },
  no_prompts: {
    EN: "No prompts found",
    FR: "Aucun prompt trouvé",
    IT: "Nessun prompt trovato",
  },
  no_prompts_subtext: {
    EN: "There are no prompts available within your property, create one!",
    FR: "Il n'y a pas de prompts disponibles dans votre propriété, créez-en un !",
    IT: "Non ci sono prompt disponibili nella tua proprietà, creane uno!",
  },
  edit_prompt: {
    EN: "Edit prompt",
    FR: "Modifier le prompt",
    IT: "Modifica prompt",
  },
  payment_pin_validation: {
    EN: "Enter your 4 character PIN to continue with payment",
    FR: "Entrez votre PIN de 4 caractères pour continuer avec le paiement",
    IT: "Inserisci il tuo PIN di 4 caratteri per continuare con il pagamento",
  },
  merchant_session_key_error_title: {
    EN: "Merchant session key error",
    FR: "Erreur de clé de session du commerçant",
    IT: "Errore della chiave di sessione del commerciante",
  },
  merchant_session_key_error_subtext: {
    EN: "The merchant session key is invalid. Please try again",
    FR: "La clé de session du commerçant est invalide. Veuillez réessayer",
    IT: "La chiave di sessione del commerciante non è valida. Riprova",
  },
  three_d_secure_confirmation_fail: {
    EN: "This link has expired or your payment was not successful. Please close this window and return to the payment page to try again or contact support",
    FR: "Ce lien a expiré ou votre paiement n'a pas réussi. Veuillez fermer cette fenêtre et revenir à la page de paiement pour réessayer ou contacter le support",
    IT: "Questo link è scaduto o il tuo pagamento non è riuscito. Si prega di chiudere questa finestra e tornare alla pagina di pagamento per riprovare o contattare il supporto",
  },
  three_d_secure_confirmation_success: {
    EN: "3D Secure confirmation successful, your payment is complete! You can close this window now",
    FR: "Confirmation 3D Secure réussie, votre paiement est complet ! Vous pouvez maintenant fermer cette fenêtre",
    IT: "Conferma 3D Secure riuscita, il tuo pagamento è completo! Ora puoi chiudere questa finestra",
  },
};

const defaultError: any = {
  EN: "Cannot find text!",
  FR: "Impossible de trouver le texte !",
  IT: "Impossibile trovare il testo!",
};

export function translateText(
  title: string,
  language: string,
  lowercase: boolean = false,
) {
  if (title in lookup) {
    const text = lookup[title][language];
    if (text === undefined) return text;
    return lowercase ? text.toLowerCase() : text;
  }
  return lowercase
    ? defaultError[language].toLowerCase()
    : defaultError[language];
}
